import {Injectable} from '@angular/core';
import {CaseNote} from './case-note';
import {Observable} from 'rxjs';

import {HttpRequestService} from '../../shared/http/http-request.service';
import {HttpOptions} from '../../shared/http/http-options';

@Injectable()
export class CaseNoteService extends HttpRequestService {
  /**
   * The endpoint that we call to get the case information.
   *
   * @type {string}
   */
  private readonly endpoint: string = 'cases/:id/notes';

  /**
   * Brings back a list of all accessible cases.
   *
   * @param {number} page The page number we are currently on.
   * @param {number} limit The number of cases to display per page.
   * @returns {Observable<CaseNote[]>}
   */
  public listCaseNotes(
      page?: number,
      limit?: number,
      options?: HttpOptions,
      query?: any
  ): Observable<CaseNote[]> {
      return this.list(this.endpoint, page, query, limit, options);
  }

  /**
   * Finds details of the case from the given ID.
   *
   * @param {string} caseId The ID of the case we require details for.
   * @returns {Observable<CaseNote>}
   */
  public findCaseNote(
      caseId: string,
      options?: HttpOptions,
  ): Observable<CaseNote> {
    return this.findById(this.endpoint, caseId, options);
  }

  /**
   * Creates a new case from the given Case object.
   *
   * @param {CaseNote} newCase The details of the case to be created.
   * @returns {Observable<CaseNote | boolean>}
   */
  public createCaseNote(
      newCase: CaseNote,
      options?: HttpOptions,
  ): Observable<CaseNote | boolean> {
    return this.create(this.endpoint, newCase, options);
  }

  /**
   * Updates a case with the given case object for the given case ID.
   *
   * @param {string} caseId The ID of the case needing updating.
   * @param {CaseNote} newDetails The new case object to update with.
   * @returns {Observable<Case | boolean>}
   */
  public updateCaseNote(
      caseId: string,
      newDetails: CaseNote,
      options?: HttpOptions,
  ): Observable<CaseNote | boolean> {
    return this.update(this.endpoint, caseId, newDetails, options);
  }

  /**
   * Deletes a case based on the given case ID.
   *
   * @param {string} caseId The ID of the case needing deleting.
   * @returns {Observable<boolean>}
   */
  public deleteCaseNote(
      caseId: string,
      options?: HttpOptions,
  ): Observable<boolean> {
    return this.delete(this.endpoint, caseId, options);
  }
}
